// Copyright (c) Bentley Systems
import { Text, Tile } from "@itwin/itwinui-react";
import IconByName from "../Icons/IconByName";
import { SvgLayers } from "@itwin/itwinui-icons-react";
import { AreaModel } from "./Models/area-model";
import { useAppDispatch } from "../app/hooks";
import { useNavigate } from "react-router-dom";
import { setActiveAreaId, setActiveNodeId } from "../app/header-slice";
import { GetUrlByNode, GetUrlByUniqueName } from "../Helpers/helper-functions";
import { useMemo, useState } from "react";

export type BecsTileProps = {
  area: AreaModel;
  setHeaderMenuWithAreas: () => void;
};

const BecsTile = (props: BecsTileProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [isFocused, setIsFocused] = useState<boolean>(false);

  function getName(name: string): import("react").ReactNode {
    return (
      <div>
        <Text as="h4" variant="leading">
          {name}
        </Text>
      </div>
    );
  }

  const getIcon = useMemo(() => {
    const icon = props.area.icon;
    if (icon !== undefined && icon !== null) {
      if (icon.base64Str !== undefined && icon.base64Str !== null) {
        return `data:image/jpeg;base64,${icon.base64Str}`;
      }
      const str = "itwinicon:";
      if (icon.name !== undefined && icon.name !== null) {
        const name = icon.name.toLowerCase();

        if (name.indexOf(str) > -1) {
          if (name.indexOf("-animated") > -1) {
            return (
              <div
                style={{
                  width: "6rem",
                  height: "6rem",
                }}
              >
                <IconByName
                  style={{ height: "90%", width: "80%" }}
                  name={name.substring(str.length).trim()}
                  isFocused={isFocused}
                />
              </div>
            );
          } else {
            return (
              <div className="becs-thumbnail-icon">
                <IconByName
                  style={{ height: "100%", width: "100%" }}
                  name={name.substring(str.length).trim()}
                />
              </div>
            );
          }
        }
      }
    }
    return <SvgLayers />;
  }, [isFocused]);

  function setAreasAndMenu(area: AreaModel) {
    dispatch(setActiveAreaId(area.applAreaId));
    if (area.nodeId) {
      dispatch(setActiveNodeId(area.nodeId));
    }
    props.setHeaderMenuWithAreas();
  }
  return (
    <Tile
      key={props.area.applAreaId}
      name={getName(props.area.name)}
      thumbnail={getIcon}
      variant="default"
      style={{ cursor: "pointer" }}
      onMouseDown={() => {
        setAreasAndMenu(props.area);
        let navstr = props.area.nodeType === 'DC' ? GetUrlByUniqueName(props.area.nodeUniqueName) : GetUrlByNode(
          props.area.nodeType,
          props.area.nodeId as number,
        );
        navstr = navstr + window.location.search;
        void navigate(navstr);
      }}
      onMouseOver={() => setIsFocused(true)}
      onMouseLeave={() => setIsFocused(false)}
    />
  );
};

export default BecsTile;
